import React, { useState, useEffect } from 'react';
import { fetchCars } from '../api/cars';
import CarCard from './car-card';

export function FeaturedCars() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [featuredCars, setFeaturedCars] = useState([]);

    useEffect(() => {
        fetchCars({ featured: true })
            .then((result) => {
                const cars = Array.isArray(result) ? result : result?.cars ?? [];
                setFeaturedCars(cars.slice(0, 3));
            })
            .catch((err) => setError(err.message || 'Error fetching featured cars'))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <div className="col-span-full rounded-2xl border border-dashed border-gray-200 bg-gray-50 px-6 py-10 text-center text-gray-500">Loading featured vehicles…</div>;
    }

    if (error) {
        return <div className="col-span-full rounded-2xl border border-red-200 bg-red-50 px-6 py-10 text-center text-red-600">Error: {error}</div>;
    }

    if (featuredCars.length === 0) {
        return <div className="col-span-full rounded-2xl border border-dashed border-gray-200 bg-gray-50 px-6 py-10 text-center text-gray-500">No featured vehicles are available right now.</div>;
    }

    return (
        <>
            {featuredCars.map((car) => (
                <CarCard key={car.id} car={car} />
            ))}
        </>
    );
}

export function NewCars() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [newCars, setNewCars] = useState([]);

    useEffect(() => {
        fetchCars({ new: true })
            .then((result) => {
                const cars = Array.isArray(result) ? result : result?.cars ?? [];
                setNewCars(cars.slice(0, 3));
            })
            .catch((err) => setError(err.message || 'Error fetching new cars'))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <div className="col-span-full rounded-2xl border border-dashed border-gray-200 bg-gray-50 px-6 py-10 text-center text-gray-500">Loading new arrivals…</div>;
    }

    if (error) {
        return <div className="col-span-full rounded-2xl border border-red-200 bg-red-50 px-6 py-10 text-center text-red-600">Error: {error}</div>;
    }

    if (newCars.length === 0) {
        return <div className="col-span-full rounded-2xl border border-dashed border-gray-200 bg-gray-50 px-6 py-10 text-center text-gray-500">No new arrivals available right now.</div>;
    }

    return (
        <>
            {newCars.map((car) => (
                <CarCard key={car.id} car={car} />
            ))}
        </>
    );
}